
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/react-native-app-development",
      function () {
        return require("private-next-pages/react-native-app-development/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/react-native-app-development"])
      });
    }
  